module.exports = __webpack_public_path__ + "img/app-mobile-image.827b2bc9.png";